import { useState, useEffect } from 'react';
import { Crosshair } from 'lucide-react';
import { useApi } from '../../../lib/useApi';

interface Props {
  accountId: string;
  orgId: string;
  signalsStatus: string;
}

interface TriggerSummary {
  title: string;
  urgency_score: number;
}

export default function TriggerPill({ accountId, orgId, signalsStatus }: Props) {
  const { apiGet } = useApi();
  const [triggers, setTriggers] = useState<TriggerSummary[]>([]);

  useEffect(() => {
    if (signalsStatus !== 'completed') return;
    (async () => {
      try {
        const { triggers: data } = await apiGet<{ triggers: TriggerSummary[] }>(
          `/v1/account/${accountId}/triggers?org_id=${encodeURIComponent(orgId)}`,
        );
        setTriggers((data || []).slice(0, 3));
      } catch {
        setTriggers([]);
      }
    })();
  }, [accountId, apiGet, orgId, signalsStatus]);

  if (signalsStatus !== 'completed' || triggers.length === 0) return null;

  const top = triggers[0];
  const urgencyColor =
    top.urgency_score >= 8 ? 'text-app-critical bg-app-critical/10 border-app-critical'
    : top.urgency_score >= 5 ? 'text-app-warning bg-app-warning/10 border-app-warning'
    : 'text-app-muted bg-app-canvas border-app-line';

  return (
    <div className="mt-2 flex items-center gap-1.5">
      <span className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full border ${urgencyColor}`}>
        <Crosshair className="w-2.5 h-2.5" />
        {top.title.length > 45 ? top.title.slice(0, 45) + '...' : top.title}
      </span>
      {triggers.length > 1 && (
        <span className="text-[10px] text-app-muted">+{triggers.length - 1}</span>
      )}
    </div>
  );
}
